<template>
  <a-modal
    title="申请提现至银行卡"
    :visible="visible"
    :confirm-loading="confirmLoading"
    ok-text="申请提现"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div v-if="!isEditCard" class="card-info">
      <div class="left">
        <div class="name">{{ formData.card_owner }}</div>
        <div>{{ formData.bank }} {{ formData.bank_branch }} </div>
        <div>{{ formData.bank_card_number }}</div>
      </div>
      <a-button type="link" class="right" @click="isEditCard=true">修改银行卡</a-button>
    </div>
    <a-form-model
      ref="form"
      :model="formData"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
    >
      <template v-if="isEditCard">
        <a-form-model-item
          label="银行"
          prop="bank"
        >
          <a-select
            v-model="formData.bank"
            placeholder="请选择银行"
            mode="combobox"
            allowClear
          >
            <a-select-option v-for="(item, index) in bankList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="银行卡号"
          prop="bank_card_number"
        >
          <a-input v-model="formData.bank_card_number" placeholder="银行卡号" allowClear />
        </a-form-model-item>
        <a-form-model-item
          label="所属支行"
          prop="bank_branch"
        >
          <a-input v-model="formData.bank_branch" placeholder="所属支行" allowClear />
        </a-form-model-item>
        <a-form-model-item
          label="持卡人姓名"
          prop="card_owner"
        >
          <a-input v-model="formData.card_owner" placeholder="持卡人姓名" allowClear />
        </a-form-model-item>
      </template>
      <a-form-model-item
        label="提现金额"
        prop="money"
      >
        <a-row :gutter="8">
          <a-col :span="17">
            <a-input-number
              v-model="formData.money"
              :min="0"
              :max="tenant_balance"
              :step="1"
              :precision="2"
              allowClear
              :placeholder="`账户余额￥${tenant_balance}`"
              style="width: 100%"
            />
          </a-col>
          <a-col :span="6">
            <a-button type="primary" size="small" @click="formData.money=tenant_balance">全部提现</a-button>
          </a-col>
        </a-row>
        <div>预计到账金额￥{{ (formData.money * (100 - service_charge_ratio) / 100).toFixed(2) }}</div>
        <div>提现需扣除 {{ service_charge_ratio }}% 的平台手续费</div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getWithdrawalPre, postWithdrawalAdd } from '@/api/withdrawal'

const defaultFormData = {
  bank: undefined,
  bank_card_number: '',
  bank_branch: '',
  card_owner: '',
  money: ''
}

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      formData: Object.assign({}, defaultFormData),
      rules: {
        bank: [{ required: true, message: '银行必填', trigger: 'change' }],
        bank_card_number: [{ required: true, message: '银行卡号必填', trigger: 'blur' }],
        bank_branch: [{ required: true, message: '所属支行必填', trigger: 'blur' }],
        card_owner: [{ required: true, message: '持卡人姓名必填', trigger: 'blur' }],
        money: [{ required: true, message: '提现金额必填', trigger: 'change' }]
      },
      bankList: [],
      service_charge_ratio: 0,
      tenant_balance: 0,
      isEditCard: true
    }
  },
  methods: {
    // 显示
    showModal(orderType, orderId) {
      this.visible = true
      this.getPre()
      this.$nextTick(() => {
        this.resetForm()
      })
    },
    // 关闭
    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    },
    // 确认
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.money <= 0) {
            this.$message.error('金额不能为0，请重新输入')
            return
          }
          this.postWithdrawalAdd()
        } else {
          // 只有提现金额时，提示 ‘请输入提现金额！’
          if (!this.isEditCard && !this.formData.money) {
            this.$message.error('请输入提现金额！')
            return false
          }
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    /**
     * 提现申请
     */
    postWithdrawalAdd() {
      postWithdrawalAdd(this.formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('申请提现成功，请静待极星云码工作人员的审核，预计三个工作日内到账')
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error('申请提现失败')
          }
        })
        .catch((e) => {
          this.$message.error('申请提现失败')
        })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.$refs.form.resetFields()
    },
    // 预加载
    getPre() {
      getWithdrawalPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.bankList = data.bankDict
            this.service_charge_ratio = data.service_charge_ratio
            this.tenant_balance = data.tenant_balance
            if (data.last_record) {
              this.isEditCard = false
              this.formData = Object.assign({}, defaultFormData, data.last_record)
            } else {
              this.isEditCard = true
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    }
  }
}
</script>
<style lang="less">
.qrcode {
  width: 200px;
  height: 200px;
  background-color: #eee;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .fresh-qrcode-btn {
    position: absolute;
    right: -50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.money {
  text-align: center;
  font-size: 18px;
  margin: 10px 0;
}
.red {
  color: red;
}
.fw-b {
  font-weight: bolder;
}
.cus-radio-group {
  display: flex;
  .cus-radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 20px;
    border: 1px solid #eee;
    margin: 10px;
    flex: 1;
    &.active {
      border: 1px solid yellow;
      background: rgba(110, 110, 110, 0.5);
      box-shadow: 0 0 4px 2px #f7ff2cb8;
    }
  }
}
.card-info{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 50px;
  line-height: 30px;
  .left{
    flex: 1;
    font-weight: bolder
  }
  .right{
    flex: none
  }
}

</style>
